<template>
  <div class="checkout-complete">
    <div class="header">
      <div class="logo-bag">
        <img src="../assets/logo.png" />
      </div>
    </div>
    <div class="checkout">
      <div class="checkout-steps">
        <div class="division">
          <div class="topico">
            <div>
              <h2>Endereço</h2>
            </div>
            <div class="icon">
              <span class="material-icons"> keyboard_arrow_down </span>
            </div>
          </div>
          <div v-if="displayContents[0]">
            <div class="input-address" v-if="cadastrar_endereco == true">
              <h2>Cadastrar endereço</h2>
              <div class="duple-input">
                <div class="unique-input">
                  <p>Identificação de endereço*</p>
                  <input
                    @change="enderecoCadastro.identificacaolocal_error = ''"
                    v-model="enderecoCadastro.identificacaolocal"
                    placeholder="Minha casa, casa de mãe, ..."
                  />
                  <p
                    v-if="enderecoCadastro.identificacaolocal_error != ''"
                    class="error"
                  >
                    {{ enderecoCadastro.identificacaolocal_error }}
                  </p>
                </div>
              </div>
              <div class="duple-input">
                <div class="unique-input">
                  <p>CEP*</p>
                  <the-mask
                    :mask="['#####-###']"
                    v-model="enderecoCadastro.cep"
                    :masked="true"
                    placeholder="_____-___"
                    @change.native="
                      enderecoCadastro.cep_error = '';
                      getCEP();
                    "
                  />
                  <p v-if="enderecoCadastro.cep_error != ''" class="error">
                    {{ enderecoCadastro.cep_error }}
                  </p>
                </div>
              </div>
              <div class="duple-input">
                <div class="unique-input">
                  <p>Endereço*</p>
                  <input
                    @change="enderecoCadastro.endereco_error = ''"
                    v-model="enderecoCadastro.endereco"
                    placeholder="Rua, Avenida, Logradouro"
                  />
                  <p v-if="enderecoCadastro.endereco_error != ''" class="error">
                    {{ enderecoCadastro.endereco_error }}
                  </p>
                </div>
                <div class="down-input">
                  <div class="unique-input">
                    <p>Número*</p>
                    <input
                      placeholder=""
                      @change="enderecoCadastro.numero_error = ''"
                      v-model="enderecoCadastro.numero"
                    />
                    <p v-if="enderecoCadastro.numero_error != ''" class="error">
                      {{ enderecoCadastro.numero_error }}
                    </p>
                  </div>
                  <div class="unique-input">
                    <p>Complemento</p>
                    <input
                      @change="enderecoCadastro.complemento_error = ''"
                      v-model="enderecoCadastro.complemento"
                      placeholder="Ex.: Apt, Blc"
                    />
                    <p
                      v-if="enderecoCadastro.complemento_error != ''"
                      class="error"
                    >
                      {{ enderecoCadastro.complemento_error }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="duple-input">
                <div class="unique-input">
                  <p>Bairro*</p>
                  <input
                    @change="enderecoCadastro.bairro_error = ''"
                    v-model="enderecoCadastro.bairro"
                    placeholder=""
                  />
                  <p v-if="enderecoCadastro.bairro_error != ''" class="error">
                    {{ enderecoCadastro.bairro_error }}
                  </p>
                </div>
                <div class="unique-input">
                  <p>Referência</p>
                  <input
                    v-model="enderecoCadastro.referencia"
                    @change="enderecoCadastro.referencia_error = ''"
                    placeholder="Ex.: Próximo ao shopping"
                  />
                  <p
                    v-if="enderecoCadastro.referencia_error != ''"
                    class="error"
                  >
                    {{ enderecoCadastro.referencia_error }}
                  </p>
                </div>
              </div>
              <div class="duple-input">
                <div class="unique-input disabled-input">
                  <p>Cidade*</p>
                  <input
                    @change="enderecoCadastro.cidade_error = ''"
                    disabled
                    v-model="enderecoCadastro.cidade"
                    placeholder=""
                  />
                  <p v-if="enderecoCadastro.cidade_error != ''" class="error">
                    {{ enderecoCadastro.cidade_error }}
                  </p>
                </div>
                <div class="unique-input disabled-input">
                  <p>Estado*</p>
                  <input
                    disabled
                    @change="enderecoCadastro.estado_error = ''"
                    v-model="enderecoCadastro.estado"
                    placeholder=""
                  />
                  <p v-if="enderecoCadastro.estado_error != ''" class="error">
                    {{ enderecoCadastro.estado_error }}
                  </p>
                </div>
              </div>
              <div class="duple-input">
                <div class="unique-input">
                  <p>Destinatário*</p>
                  <input
                    @change="enderecoCadastro.destinatario_error = ''"
                    v-model="enderecoCadastro.destinatario"
                    placeholder="Nome completo impresso na nota fiscal"
                  />
                  <p
                    v-if="enderecoCadastro.destinatario_error != ''"
                    class="error"
                  >
                    {{ enderecoCadastro.destinatario_error }}
                  </p>
                </div>
                <div class="unique-input">
                  <p>Telefone do destinatário*</p>
                  <the-mask
                    @change.native="
                      enderecoCadastro.telefone_destinatario_error = ''
                    "
                    :mask="['(##) #####-####', '(##) ####-####']"
                    v-model="enderecoCadastro.telefone_destinatario"
                    :masked="true"
                    placeholder="DDD + Número celular ou fixo do destinatário"
                  />
                  <p
                    v-if="enderecoCadastro.telefone_destinatario_error != ''"
                    class="error"
                  >
                    {{ enderecoCadastro.telefone_destinatario_error }}
                  </p>
                </div>
              </div>
              <div class="btns-add-address-options">
                <div
                  class="btn-add-address"
                  v-if="enderecos.length > 0"
                  @click="cadastrar_endereco = false"
                >
                  <div
                    class="btn-detail"
                    style="background-color: #fff; color: #000"
                  >
                    <p>Voltar</p>
                  </div>
                </div>
                <div class="btn-add-address" @click="createEndereco()">
                  <div class="btn-detail">
                    <p>Enviar para esse endereço</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="select-address" v-else>
              <p>Selecione o seu endereço:</p>

              <div
                v-for="item in enderecos"
                :key="item._id"
                class="item-address-saved"
              >
                <p class="indentfy-item-address">{{ item.identificacao }}</p>
                <div class="item-address-saved-info">
                  <div
                    class="radio-button"
                    @click="
                      entregalugar = item._id;
                      getFrete();
                    "
                  >
                    <div
                      v-if="entregalugar == item._id"
                      style="
                        background-color: #000;
                        width: 80%;
                        border-radius: 15px;
                        height: 80%;
                      "
                    ></div>
                  </div>
                  <div>
                    <p>{{ item.rua }}, {{ item.numero }}</p>
                    <p>
                      {{ item.bairro }}, {{ item.cidade }} - {{ item.estado }}
                    </p>
                    <p>CEP: {{ item.cep }}</p>
                  </div>
                </div>
              </div>

              <!-- <select v-model="endereco" @change="getFrete()">
                <option disable value>Escolha um endereço</option>
                <option
                  v-for="item in enderecos"
                  :key="item._id"
                  :value="item._id"
                >
                  <div style="">
                    <p>{{ item.rua }}, {{ item.numero }}</p>
                    <p>
                      {{ item.bairro }}, {{ item.cidade }} - {{ item.estado }}
                    </p>
                    <p>CEP: {{ item.cep }}</p>
                  </div>
                </option>
              </select> -->
              <div
                class="item-address-saved"
                @click="cadastrar_endereco = true"
              >
                <p style="display: flex; align-items: center">
                  <span style="width: 30px" class="material-icons">
                    add_circle_outline
                  </span>
                  Cadastrar novo endereço
                </p>
              </div>
              <div class="btn-add-address" @click="disponibilidade(true)">
                <div class="btn-detail">
                  <p>Enviar para esse endereço</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="division">
          <div class="topico">
            <div>
              <h2>Formas de Entrega</h2>
            </div>
            <div class="icon">
              <span class="material-icons"> keyboard_arrow_down </span>
            </div>
          </div>
          <div v-if="displayContents[1]">
            <div v-if="loading_total">
              <transition name="modal">
                <div class="modal-mask">
                  <div class="modal-wrapper">
                    <activity-indicator size="40" color="#ffffff" />
                  </div>
                </div>
              </transition>
            </div>
            <div v-else class="delivery-form-options">
              <div style="padding-left: 20px; padding-bottom: 20px">
                <h3>Receber em casa</h3>
                <div class="store-take">
                  <div
                    class="select"
                    @click="
                      receber = 'home';
                      getTotal();
                    "
                  >
                    <div
                      v-if="receber == 'home'"
                      style="
                        height: 15px;
                        border-radius: 8px;
                        width: 15px;
                        background-color: #000;
                      "
                    ></div>
                  </div>
                  <div>
                    <p>Correios - PAC</p>
                    <p>Em até 15 dias úteis</p>
                    <p>
                      <b>R$ {{ frete.toFixed(2).replace(".", ",") }}</b>
                    </p>
                  </div>
                </div>
              </div>
              <div class="checkout-forma-entrega-divisoria" style="">
                <h3>Retirar na loja</h3>
                <div class="store-take">
                  <div
                    class="select"
                    @click="
                      receber = 'store';
                      getTotal();
                    "
                  >
                    <div
                      v-if="receber == 'store'"
                      style="
                        height: 15px;
                        border-radius: 8px;
                        width: 15px;
                        background-color: #000;
                      "
                    ></div>
                  </div>
                  <div>
                    <p>Loja Emaús - Av. Brigadeiro Eduardo Gomes, 250</p>
                    <p><b>Grátis</b></p>
                  </div>
                </div>
              </div>
            </div>

            <div class="btn-add-address" @click="validarEntrega()">
              <div class="btn-detail">
                <p>Selecionar Entrega</p>
              </div>
            </div>
          </div>
        </div>

        <div class="division">
          <div class="topico">
            <div>
              <h2>Pagamento</h2>
            </div>
            <div class="icon">
              <span class="material-icons"> keyboard_arrow_down </span>
            </div>
          </div>

          <div v-if="displayContents[2]">
            <!-- <form action="#" method="post" id="paymentForm">
              <h3>Detalhe do comprador</h3>
              <div class="input-address">
                <div class="unique-input">
                  <label for="email" style="text-align: left">E-mail</label>
                  <input
                    id="email"
                    name="email"
                    type="text"
                    value="test@test.com"
                  />
                </div>
                <div class="unique-input">
                  <label for="docType">Tipo de documento</label>
                  <select
                    id="docType"
                    name="docType"
                    data-checkout="docType"
                    type="text"
                  ></select>
                </div>
                <div class="unique-input">
                  <label for="docNumber">Número do documento</label>
                  <input
                    id="docNumber"
                    name="docNumber"
                    data-checkout="docNumber"
                    type="text"
                  />
                </div>
              </div>
              <h3>Detalhes do cartão</h3>
              <div class="input-address">
                <div class="unique-input">
                  <label for="cardholderName">Titular do cartão</label>
                  <input
                    id="cardholderName"
                    data-checkout="cardholderName"
                    type="text"
                  />
                </div>
                <div class="unique-input">
                  <label for="">Data de vencimento</label>
                  <div
                    class="duple-input"
                    style="align-items: center; width: 200px"
                  >
                    <input
                      type="text"
                      placeholder="MM"
                      id="cardExpirationMonth"
                      data-checkout="cardExpirationMonth"
                      onselectstart="return false"
                      onpaste="return false"
                      oncopy="return false"
                      oncut="return false"
                      ondrag="return false"
                      ondrop="return false"
                      autocomplete="off"
                    />
                    <span class="date-separator">/</span>
                    <input
                      type="text"
                      placeholder="YY"
                      id="cardExpirationYear"
                      data-checkout="cardExpirationYear"
                      onselectstart="return false"
                      onpaste="return false"
                      oncopy="return false"
                      oncut="return false"
                      ondrag="return false"
                      ondrop="return false"
                      autocomplete="off"
                    />
                  </div>
                </div>
                <div class="unique-input">
                  <label for="cardNumber">Número do cartão</label>
                  <input
                    type="text"
                    id="cardNumber"
                    data-checkout="cardNumber"
                    onselectstart="return false"
                    onpaste="return false"
                    oncopy="return false"
                    oncut="return false"
                    ondrag="return false"
                    ondrop="return false"
                    autocomplete="off"
                  />
                </div>
                <div class="unique-input">
                  <label for="securityCode">Código de segurança</label>
                  <input
                    id="securityCode"
                    data-checkout="securityCode"
                    type="text"
                    onselectstart="return false"
                    onpaste="return false"
                    oncopy="return false"
                    oncut="return false"
                    ondrag="return false"
                    ondrop="return false"
                    autocomplete="off"
                  />
                </div>
                <div class="unique-input" id="issuerInput">
                  <label for="issuer">Banco emissor</label>
                  <select
                    id="issuer"
                    name="issuer"
                    data-checkout="issuer"
                  ></select>
                </div>
                <div class="unique-input">
                  <label for="installments">Parcelas</label>
                  <select
                    type="text"
                    id="installments"
                    name="installments"
                  ></select>
                </div>
                <div class="unique-input">
                  <input
                    type="hidden"
                    name="transactionAmount"
                    id="transactionAmount"
                    value="100"
                  />
                  <input
                    type="hidden"
                    name="paymentMethodId"
                    id="paymentMethodId"
                  />
                  <input type="hidden" name="description" id="description" />
                  <br />
                  <button type="submit">Pagar</button>
                  <br />
                </div>
              </div>
            </form> -->

            <select v-model="pagamento" id="input-mask" @change="desconto()">
              <option disable value>Escolha uma forma de pagamento</option>
              <option>Cartão de Crédito (VISA)</option>
              <option>Cartão de Crédito (MASTERCARD)</option>
            </select>

            <div v-if="pagamento" class="unique-input">
              <p id="info">Insira os dados do seu cartão de crédito abaixo:</p>
              <the-mask
                id="input-mask"
                :mask="['####.####.####.####', '####.####.####.###']"
                v-model="cartao.number"
                placeholder="Número do Cartão de Crédito"
              />

              <div id="divisao_card" class="unique-input">
                <the-mask
                  id="input-mask"
                  :mask="['##/####']"
                  v-model="cartao.vencimento"
                  :masked="true"
                  placeholder="Venc. Ex. 01/2050"
                />
                <the-mask
                  id="input-mask"
                  :mask="['###', '####']"
                  v-model="cartao.securitycode"
                  :masked="true"
                  placeholder="CVV"
                />
              </div>
              <div class="unique-input">
                <input
                  v-model="cartao.name"
                  id="input-mask"
                  placeholder="Nome escrito no cartão"
                />
              </div>
              <div class="unique-input">
                <p>Parcelas</p>
                <select
                  v-model="parcelas"
                  id="input-mask"
                  :change="descontoValor()"
                >
                  <option disable value>Escolha as parcelas</option>
                  <option
                    v-for="qnt in parcelasPossiveis"
                    :key="qnt"
                    :value="qnt"
                  >
                    {{ qnt }}x
                  </option>
                </select>
              </div>
            </div>
            <p
              v-if="campos_necessarios_card"
              style="color: red; font-size: 14px; font-weight: 600"
            >
              Todos os dados são necessários!
            </p>
            <p
              v-if="campos_invalidos_card"
              style="color: red; font-size: 14px; font-weight: 600"
            >
              Verifique os dados do cartão de crédito!
            </p>

            <!-- 
        <select v-model="pagamento" @change="desconto()">
          <option disable value>Escolha uma forma de pagamento</option>
          <option>Link via WhatsApp (Parc. Cartão de Crédito)</option>
          <option>Link via WhatsApp (À vista Cartão de Crédito)</option>
        </select>-->

            <div
              v-if="
                pagamento === 'Link via WhatsApp (Parc. Cartão de Crédito)' ||
                pagamento === 'Link via WhatsApp (À vista Cartão de Crédito)'
              "
            >
              <input v-model="whatsapp" placeholder="Informe seu WhatsApp" />
              <p id="info">
                Você receberá um link para pagamento do nosso WhatsApp oficial
                (84) 9 9891-8064
              </p>
              <p id="info">Fique atento ao número!</p>
            </div>
            <div id="button_">
              <div class="btn-add-address" @click="goTo(4)">
                <div class="btn-detail">
                  <p>Realizar Pagamento</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="division">
          <div class="topico">
            <div>
              <h2>Dados cartões</h2>
            </div>
            <div class="icon">
              <span class="material-icons"> keyboard_arrow_down </span>
            </div>
          </div>

          <div v-if="displayContents[3]">
            <div>
              <p v-if="this.parcelas === 1 && this.total_all">
                Total: R$ {{ this.total_all.toFixed(2).replace(".", ",") }}
              </p>
              <p v-if="this.total">
                Total a pagar: R$ {{ this.total.toFixed(2).replace(".", ",") }}
              </p>
              <p>Parcelas: {{ this.parcelas }}</p>
            </div>
            <div id="button_back_finalizar">
              <button type="button" @click="goTo(3)">Voltar</button>
            </div>
            <div id="button_">
              <button type="button" id="btn_text" @click="goTo(5)">
                Finalizar
              </button>
            </div>
          </div>
        </div> -->

        <div v-if="loading">
          <transition name="modal">
            <div class="modal-mask">
              <div class="modal-wrapper">
                <activity-indicator size="40" color="#ffffff" />
              </div>
            </div>
          </transition>
        </div>

        <!-- template for the modal component -->
        <div v-if="showModal">
          <transition name="modal">
            <div class="modal-mask">
              <div class="modal-wrapper">
                <div class="modal-container">
                  <div class="modal-header">
                    <i class="material-icons" id="done_icon">done</i>
                    <div class="pedidorealizado">
                      <slot name="header">Pedido realizado com sucesso!</slot>
                    </div>
                  </div>

                  <div class="modal-body">
                    <!-- <slot name="body">default body</slot> -->
                  </div>

                  <div class="modal-Footerr">
                    <slot name="Footerr">
                      <router-link :to="`/account`" class="btn-ver-pedidos">
                        <div class="footer-text">
                          Ver meus pedidos
                        </div></router-link
                      >
                    </slot>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div v-if="error_message.visible">
          <transition name="modal">
            <div class="modal-mask">
              <div class="modal-wrapper">
                <div class="modal-container">
                  <div class="modal-header">
                    <i class="material-icons" id="wrong_icon">close</i>
                    <slot name="header">
                      <p id="message_error">
                        {{ error_message.message }} ({{ error_message.code }})
                      </p>
                    </slot>
                  </div>

                  <div class="modal-body">
                    <!-- <slot name="body">default body</slot> -->
                  </div>

                  <div class="modal-Footerr">
                    <slot name="Footerr">
                      <button type="button" @click="retry()" id="btn_error">
                        Tentar Novamente
                      </button>
                    </slot>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="checkout-detail">
        <div class="info">
          <p class="title">Resumo do pedido</p>

          <div class="subprice">
            <p>Subtotal</p>
            <p class="price">
              <b>R$ {{ subprice.toFixed(2).replace(".", ",") }}</b>
            </p>
          </div>
          <div class="subprice" v-if="frete >= 0 && receber != 'store'">
            <p>Frete</p>
            <p class="price">
              <b>R$ {{ frete.toFixed(2).replace(".", ",") }}</b>
            </p>
          </div>
          <div class="total">
            <p>Total</p>
            <p class="price">
              <b>R$ {{ total.toFixed(2).replace(".", ",") }}</b>
            </p>
          </div>
        </div>
        <div class="info">
          <p class="title">Itens do pedido</p>

          <div
            :v-if="sacolacompras"
            v-for="item in sacolacompras"
            :key="item.item._id"
            class="item-detail-info"
          >
            <div>
              <img :src="item.item.url" class="img-product" />
            </div>
            <div class="detail-buy">
              <p>{{ item.item.nome }}</p>
              <p>Quantidade: {{ item.qntSelecionado }}</p>
              <p>Tamanho: {{ item.item.tamanho }}</p>
              <p class="price">
                R$ {{ item.valor.toFixed(2).replace(".", ",") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { TheMask } from "vue-the-mask";
// import qs from "qs";
import rp from "request-promise";
export default {
  components: {
    TheMask,
  },
  data() {
    return {
      endereco: "",
      parcelas: 1,
      pagamento: "",
      loading: false,
      whatsapp: "",
      campos_necessarios_card: false,
      campos_invalidos_card: false,
      parcelasPossiveis: [],
      showModal: false,
      receber: "",
      entregalugar: "",
      enderecoCadastro: {
        identificacaolocal: "",
        cep: "",
        endereco: "",
        numero: "",
        complemento: "",
        bairro: "",
        referencia: "",
        cidade: "",
        estado: "",
        destinatario: "",
        telefone_destinatario: "",
        // Casos de erros
        identificacaolocal_error: "",
        cep_error: "",
        endereco_error: "",
        numero_error: "",
        complemento_error: "",
        bairro_error: "",
        referencia_error: "",
        cidade_error: "",
        estado_error: "",
        destinatario_error: "",
        telefone_destinatario_error: "",
      },
      frete: -1,
      sacolacompras: [],
      total: 0,
      total_all: 0,
      retentativa: false,
      venda: null,
      loading_total: false,
      cadastrar_endereco: true,
      subprice: 0,
      error_message: {
        message: "ERROR",
        code: 100,
        visible: false,
      },
      access_token: "",
      cartao: {
        number_token: "",
        number: "",
        name: "",
        securitycode: "",
        brand: "",
        vencimento: "",
      },
      displayContents: [true, false, false, false],
      enderecos: [],
    };
  },
  beforeMount() {
    let user = JSON.parse(localStorage.getItem("usuario"));
    if (!user) {
      this.$router.push("/login?l=true");
    }
    this.getEnderecos(user);

    // this.getSacola();
  },
  mounted() {
    this.getSacola();
    try {
      window.Mercadopago.setPublishableKey(
        "TEST-f16c3171-f133-4015-bbf3-35bd3fcc5b70"
      );
      window.Mercadopago.getIdentificationTypes();

      console.log("TERMINOU");
    } catch (err) {
      console.error(err);
      console.error("ERRO COM O MERCADO PAGO");
    }
  },
  methods: {
    getFrete() {
      this.total = 0;
      this.$http
        .post(`/projects/loja/frete`, { endereco: this.entregalugar })
        .then((res) => {
          this.frete = res.data.frete;
          this.getTotal();
          this.loading_total = false;
        })
        .catch(() => {
          this.frete = 30;
          this.getTotal();
          this.loading_total = false;
        });
    },
    getTotal() {
      try {
        const cart = JSON.parse(localStorage.getItem("sacola"));
        let valor = 0;

        for (let e of cart) {
          valor += e.qntSelecionado * e.item.preco.preco_venda;
        }
        this.subprice = valor;

        if (this.receber != "store") {
          this.total = valor + this.frete;
          this.total_all = valor + this.frete;
        } else {
          this.total = valor;
        }
        this.calcularQntParcelas();
      } catch (err) {
        this.$router.push("/");
      }
    },
    validarEntrega() {
      if (this.receber != "") {
        this.displayContents = [false, false, true, false];
      }
    },
    createEndereco() {
      if (
        this.enderecoCadastro.identificacaolocal &&
        this.enderecoCadastro.cep &&
        this.enderecoCadastro.endereco &&
        this.enderecoCadastro.numero &&
        this.enderecoCadastro.bairro &&
        this.enderecoCadastro.cidade &&
        this.enderecoCadastro.estado &&
        this.enderecoCadastro.destinatario &&
        this.enderecoCadastro.telefone_destinatario
      ) {
        let user = JSON.parse(localStorage.getItem("usuario"));
        this.$http
          .post(`/projects/cliente/endereco/${user.cliente._id}`, {
            identificacao: this.enderecoCadastro.identificacaolocal,
            referencia: this.enderecoCadastro.referencia,
            rua: this.enderecoCadastro.endereco,
            numero: this.enderecoCadastro.numero,
            cidade: this.enderecoCadastro.cidade,
            complemento: this.enderecoCadastro.complemento,
            bairro: this.enderecoCadastro.bairro,
            estado: this.enderecoCadastro.estado,
            cep: this.enderecoCadastro.cep,
            destinatario: this.enderecoCadastro.destinatario,
            telefonedestinatario: this.enderecoCadastro.telefone_destinatario,
          })
          .then(() => {
            this.enderecoCadastro.identificacaolocal = "";
            this.enderecoCadastro.cep = "";
            this.enderecoCadastro.endereco = "";
            this.enderecoCadastro.numero = "";
            this.enderecoCadastro.bairro = "";
            this.enderecoCadastro.cidade = "";
            this.enderecoCadastro.estado = "";
            this.enderecoCadastro.destinatario = "";
            this.enderecoCadastro.telefone_destinatario = "";
            this.getEnderecos(user);
            // if (this.$route.query.g === "na") this.$router.push(`/checkout`);
          })
          .catch((err) => {
            this.error_message = err.error;
          });
      } else {
        if (this.enderecoCadastro.identificacaolocal == "")
          this.enderecoCadastro.identificacaolocal_error = "Campo necessário";
        if (this.enderecoCadastro.cep == "")
          this.enderecoCadastro.cep_error = "Campo necessário";
        if (this.enderecoCadastro.endereco == "")
          this.enderecoCadastro.endereco_error = "Campo necessário";
        if (this.enderecoCadastro.numero == "")
          this.enderecoCadastro.numero_error = "Campo necessário";
        if (this.enderecoCadastro.bairro == "")
          this.enderecoCadastro.bairro_error = "Campo necessário";
        if (this.enderecoCadastro.cidade == "")
          this.enderecoCadastro.cidade_error = "Campo necessário";
        if (this.enderecoCadastro.estado == "")
          this.enderecoCadastro.estado_error = "Campo necessário";
        if (this.enderecoCadastro.destinatario == "")
          this.enderecoCadastro.destinatario_error = "Campo necessário";
        if (this.enderecoCadastro.telefone_destinatario == "")
          this.enderecoCadastro.telefone_destinatario_error =
            "Campo necessário";
        this.necessary = true;
      }
    },
    async getCEP() {
      console.log("CHAMOU");
      await axios
        .get(`https://viacep.com.br/ws/${this.enderecoCadastro.cep}/json`)
        .then((res) => {
          let endereco_ = res.data;
          this.enderecoCadastro.endereco = endereco_.logradouro;
          this.enderecoCadastro.bairro = endereco_.bairro;
          this.enderecoCadastro.cidade = endereco_.localidade;
          this.enderecoCadastro.estado = endereco_.uf;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getEnderecos(user) {
      this.loading = true;
      this.$http
        .get(`/projects/cliente/enderecos/${user.cliente._id}`)
        .then(async (res) => {
          let ende = res.data;

          this.enderecos = ende;

          if (ende.length === 0) {
            this.loading = false;
            this.$router.push("/account?g=na");
          } else {
            this.endereco = ende[0]._id;
            this.entregalugar = ende[0]._id;
            this.getFrete();
            this.loading = false;
            this.cadastrar_endereco = false;
            await this.disponibilidade();
          }
        })
        .catch((err) => {
          if (err.error == "Token invalid") {
            localStorage.setItem("usuario", null);
            this.$router.push("/login");
          } else {
            this.loading = false;
            this.error_message.message = "Sem conexão com a internet";
            this.error_message.code = 101;
            this.error_message.visible = true;
          }
        });
    },
    desconto() {
      this.getTotal();
      if (this.pagamento === "Cartão de Crédito (VISA)") {
        this.cartao.brand = "VISA";
      } else if (this.pagamento === "Cartão de Crédito (MASTERCARD)") {
        this.cartao.brand = "MASTER";
      }

      if (this.pagamento === "Link via WhatsApp (À vista Cartão de Crédito)") {
        let sub = this.total - this.frete;
        this.total = sub - (sub * 10) / 100 + this.frete;
      }
    },
    descontoValor() {
      this.getTotal();
      if (this.parcelas === 1) {
        let sub = this.total - this.frete;
        this.total = sub - (sub * 10) / 100 + this.frete;
      }
    },
    async goTo(value) {
      switch (value) {
        case 1:
          this.displayContents = [true, false, false, false];
          break;
        case 2:
          this.loading = true;
          // await this.iniciarSessao();
          this.displayContents = [false, true, false, false];
          this.loading = false;
          this.loading_total = false;
          break;
        case 3:
          this.loading = true;
          this.displayContents = [false, false, true, false];
          this.loading = false;
          break;
        case 4:
          if (
            this.cartao.number &&
            this.cartao.name &&
            this.cartao.securitycode &&
            this.cartao.brand &&
            this.cartao.vencimento
          ) {
            if (
              (this.cartao.number.length === 16 ||
                this.cartao.number.length === 15) &&
              (this.cartao.securitycode.length === 3 ||
                this.cartao.securitycode.length === 4) &&
              this.cartao.vencimento.length === 7
            ) {
              this.loading = true;
              //await this.tokenizarCartao();
              // await this.verificarCartao();
              // this.displayContents = [false, false, false, true];
              // this.loading = false;
              this.descontoValor();
              this.goTo(5);
            } else {
              this.campos_invalidos_card = true;
              console.log("AQUI1");
            }
          } else {
            this.campos_necessarios_card = true;
            console.log("AQUI2");
          }
          break;
        case 5:
          this.loading = true;
          if (this.retentativa === false) {
            await this.realizarPedido();
          } else {
            await this.pagarCartaoCredito();
          }
          this.loading = false;
          break;
        default:
          break;
      }
    },
    calcularQntParcelas() {
      let parcelas = [];
      let e = 1;

      while (this.total / e > 50) {
        parcelas.push(e);
        e++;
      }

      if (parcelas.length === 0) {
        parcelas.push(1);
      }

      this.parcelasPossiveis = parcelas;
    },
    getSacola() {
      const cart = JSON.parse(localStorage.getItem("sacola"));
      console.log("CARTT");
      console.log(cart);
      this.sacolacompras = cart;
    },
    realizarPedido() {
      let user = JSON.parse(localStorage.getItem("usuario"));

      const cart = JSON.parse(localStorage.getItem("sacola"));
      let qnt = 0;
      let produtos = [];

      for (let e of cart) {
        qnt += e.qntSelecionado;
        let entr = {
          id_prod: e.item._id,
          qntSolicitada: e.qntSelecionado,
        };

        if (e && e.item.preco.preco_desconto) {
          entr["valor"] = e.item.preco.preco_desconto;
        } else {
          entr["valor"] = e.item.preco.preco_venda;
        }

        produtos.push(entr);
      }

      let data = {
        local: "WEB",
        endereco: this.endereco,
        status: "criado",
        tipoPagamento: "Cartão",
        formaPagamento: "Crédito",
        comprador: user.user._id,
        parcelas: this.parcelas,
        receber: this.receber,
        produtos: produtos,
        quantidade: qnt,
        frete: this.frete,
        precoPago: this.total,
        valorTotal: this.total,
      };

      this.$http
        .post(`/projects/venda/app`, data)
        .then(async (res) => {
          this.venda = res.data.venda;
          this.retentativa = true;
          // await this.pagarCartaoCredito();
        })
        .catch(() => {
          this.loading = false;

          this.error_message.message = "Não foi possível realizar o pedido!";
          this.error_message.code = 102;
          this.error_message.visible = true;
        });
    },
    // async iniciarSessao() {
    //   let data = {
    //     scope: "oob",
    //     grant_type: "client_credentials"
    //   };

    //   await axios({
    //     method: "post",
    //     url: "https://api-sandbox.getnet.com.br/auth/oauth/v2/token",
    //     data: qs.stringify(data),
    //     headers: {
    //       "Content-Type": "application/x-www-form-urlencoded",
    //       Authorization:
    //         "Basic OGFhNmI0MjAtZTFkMy00Mjg5LTg0ZDUtZDk3OTdhODI5ZjFjOjg5MzI4NTViLWI4M2YtNDE5NS1iOGI4LTRiMmFlODEyY2ZkOA=="
    //     }
    //   })
    //     .then(res => {
    //       this.access_token = res.data.access_token;
    //     })
    //     .catch(() => {
    //       this.error_message.message =
    //         "Ops! O sistema está indisponível, tente novamente mais tarde!";
    //       this.error_message.code = 103;
    //       this.error_message.visible = true;
    //     });
    // },
    // async tokenizarCartao() {
    //   let user = JSON.parse(localStorage.getItem("usuario"));
    //   await axios({
    //     method: "post",
    //     url: "https://api-sandbox.getnet.com.br/v1/tokens/card",
    //     data: {
    //       card_number: this.cartao.number,
    //       customer_id: user.user._id
    //     },
    //     headers: {
    //       "Content-Type": "application/json; charset=utf-8",
    //       Authorization: `Bearer ${this.access_token}`,
    //       seller_id: "c494035a-ec81-4fae-b6c3-bd304d3fbf76"
    //     }
    //   })
    //     .then(res => {
    //       this.cartao.number_token = res.data.number_token;
    //     })
    //     .catch(err => {
    //       this.loading = false;
    //       this.goTo(3);
    //       this.error_message.message =
    //         "Ops! O sistema está indisponível, tente novamente mais tarde!";
    //       this.error_message.code = 103;
    //       this.error_message.visible = true;
    //       console.log(err);
    //     });
    // },
    // async verificarCartao() {
    //   let data_cartao = this.cartao.vencimento.split("/");
    //   await axios({
    //     method: "post",
    //     url: "https://api-sandbox.getnet.com.br/v1/cards/verification",
    //     data: {
    //       number_token: this.cartao.number_token,
    //       brand: this.cartao.brand,
    //       cardholder_name: this.cartao.name,
    //       expiration_month: data_cartao[0],
    //       expiration_year: data_cartao[1],
    //       security_code: this.cartao.securitycode
    //     },
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${this.access_token}`,
    //       seller_id: "c494035a-ec81-4fae-b6c3-bd304d3fbf76"
    //     }
    //   })
    //     .then(res => {
    //       console.log(res.data);

    //       if (res.data.status == "VERIFIED") return true;
    //       else return false;
    //     })
    //     .catch(err => {
    //       this.goTo(3);
    //       this.loading = false;
    //       this.error_message.message =
    //         "Ops! O sistema está indisponível, tente novamente mais tarde!";
    //       this.error_message.code = 104;
    //       this.error_message.visible = true;
    //       console.log(err);
    //     });
    // },
    retry() {
      this.goTo(1);
      this.error_message.visible = false;
    },
    async disponibilidade(op = false) {
      try {
        console.log(this.sacolacompras);
        let r = await this.$http.post(
          "/projects/produto/disponibilidade/verify",
          { items: this.sacolacompras }
        );
        let retorno = r.data;
        console.log(retorno);
        if (retorno.not.length > 0) {
          alert("Produtos no seu carrinho estão foram de estoque");
          localStorage.setItem("sacola", []);
          window.location.href = "/";
          console.log("MODAL MOSTRANDO A MENSAGEM");
        } else {
          if (op) this.displayContents = [false, true, false, false];
        }
      } catch (err) {
        console.log(err);
        alert(err.error);
      }
    },
    async pagarCartaoCredito() {
      this.loading = true;
      let valorTotal_centavos = parseInt(
        parseFloat(this.total).toFixed(2) * 100
      );
      let user = JSON.parse(localStorage.getItem("usuario"));
      let endereco = null;

      for (let e of this.enderecos) {
        if (e._id === this.endereco) {
          endereco = e;
        }
      }

      // let tipo_pag = "FULL";
      // if (this.parcelas != 1) {
      //   tipo_pag = "INSTALL_NO_INTEREST";
      // }

      //let data_cartao = this.cartao.vencimento.split("/");

      if (!user.cliente && endereco) {
        localStorage.setItem("usuario", null);
        this.$router.push("/sacola");
      } else {
        let dados__ = {
          MerchantOrderId: this.venda._id,
          Customer: {
            Name: (user.cliente.nome + " " + user.cliente.sobrenome).slice(
              0,
              254
            ),
            Email: user.user.email.slice(0, 254),
            Address: {
              Street: endereco.rua.slice(0, 254),
              Number: endereco.numero.slice(0, 14),
              Complement: endereco.complemento.slice(0, 49),
              ZipCode: endereco.cep.slice(0, 8),
              City: endereco.cidade.slice(0, 49),
              State: endereco.estado.slice(0, 2),
              Country: "BRA",
            },
          },
          Payment: {
            Type: "CreditCard",
            Currency: "BRL",
            Amount: valorTotal_centavos,
            Country: "BRA",
            ServiceTaxAmount: 0,
            Installments: this.parcelas,
            Capture: false,
            Authenticate: false,
            Recurrent: false,
            SoftDescriptor: "Emporio",
            CreditCard: {
              CardNumber: this.cartao.number,
              Holder: this.cartao.name,
              ExpirationDate: this.cartao.vencimento,
              SecurityCode: this.cartao.securitycode,
              Brand: this.cartao.brand,
            },
          },
        };

        if (this.venda) {
          // var options = {
          //   method: "POST",
          //   uri: "https://api.cieloecommerce.cielo.com.br/1/sales",
          //   body: dados__,
          //   headers: {
          //     MerchantId: "0c7689e9-2867-4bfa-a193-c29c01d6d0f8",
          //     "Content-Type": "application/json",
          //     MerchantKey: "bkz5Y6iP2a5pFcGVTtAohO6lBsRQH707ey3401n2",
          //   },
          //   json: true,
          // };

          var options = {
            method: "POST",
            uri: "https://apisandbox.cieloecommerce.cielo.com.br/1/sales",
            body: dados__,
            headers: {
              MerchantId: "678c1161-7e03-4a0b-adbc-d87c22f37bd5",
              "Content-Type": "application/json",
              MerchantKey: "JTGPDEWHNWXKSHUTZMNGUMBOJNQQTZNCEQWNRQCX",
            },
            json: true,
          };

          rp(options).then(this.update).catch(this.error_generic);

          // await axios({
          //   crossdomain : true,
          //   method: "post",
          //   headers: {
          //     MerchantId: "",
          //     "Content-Type": "application/json",
          //     MerchantKey: ""
          //   },
          //   url: "",
          //   data: qs.stringify(dados__)
          // })
          //   .then(res => {
          //     console.log(res.data);

          //     if (res.data.Payment.Status === 2) {
          //       this.$http
          //         .post(`/projects/pagamento/${this.venda._id}`, {
          //           resultado: JSON.stringify(res.data),
          //           payment_id: res.data.Payment.PaymentId
          //         })
          //         .then(() => {
          //           this.showModal = true;
          //           console.log("Processo foi perfeito!");

          //           localStorage.setItem("sacola", []);
          //         })
          //         .catch(() => {
          //           this.loading = false;
          //           this.showModal = true;
          //           localStorage.setItem("sacola", []);
          //         });
          //     } else {
          //       this.loading = false;
          //       this.error_message.message = "Transação não autorizada!";
          //       this.error_message.code = 106;
          //       this.retentativa = true;
          //       this.error_message.visible = true;
          //     }
          //   })
          //   .catch(err => {
          //     this.loading = false;
          //     console.log(err);

          //     this.error_message.message = "Transação não autorizada!";
          //     this.error_message.code = 105;
          //     this.retentativa = true;
          //     this.error_message.visible = true;
          //     this.goTo(3);
          //   });
        }
      }
    },
    error_generic() {
      this.loading = false;

      this.error_message.message = "Transação não autorizada!";
      this.error_message.code = 105;
      this.retentativa = true;
      this.error_message.visible = true;
      this.$http.post(`/projects/vendas/status/erro/card/${this.venda._id}`);
      this.goTo(3);
    },
    update(res) {
      console.log("ENTROU ETAPA 1");
      console.log(res);
      if (
        res.Payment.Status === 2 ||
        res.Payment.Status === 1 ||
        res.Payment.ReturnCode === "00"
      ) {
        this.$http
          .post(`/projects/pagamento/${this.venda._id}`, {
            resultado: JSON.stringify(res),
            payment_id: res.Payment.PaymentId,
          })
          .then(() => {
            this.showModal = true;
            console.log("Processo foi perfeito!");

            localStorage.setItem("sacola", []);
          })
          .catch(() => {
            this.loading = false;
            this.showModal = true;
            localStorage.setItem("sacola", []);
          });

        this.loading = false;
      } else {
        this.loading = false;
        this.error_message.message = "Transação não autorizada!";
        this.error_message.code = 106;
        this.retentativa = true;
        this.error_message.visible = true;
      }
    },
  },
};
</script>

<style>
.checkout-complete {
  align-items: center;
  justify-items: center;
}

.checkout-complete .checkout {
  display: flex;
  margin: 0 auto;
  align-items: flex-start;
  justify-self: center;
}

.checkout-complete .checkout .checkout-steps .division .topico {
  display: flex;
  text-align: left;
  padding: 10px;
  background-color: rgba(45, 45, 45, 0.3);
  color: #000;
}

.checkout-complete .checkout .checkout-steps .division .topico .icon {
}

.checkout-complete .checkout .checkout-steps .division .topico span {
  display: flex;
  align-self: flex-end;
}

.checkout-complete .checkout-steps .division .select-address {
  text-align: left;
  color: #000;
  margin: 20px;
}

.checkout-complete
  .checkout-steps
  .division
  .select-address
  .item-address-saved {
  border: 2px solid #ccc;
  margin: 10px 0px;
  padding: 20px;
  border-radius: 10px;
  align-items: center;
}

.checkout-complete
  .checkout-steps
  .division
  .select-address
  .item-address-saved
  .item-address-saved-info {
  display: flex;
}

.checkout-complete
  .checkout-steps
  .division
  .select-address
  .item-address-saved
  .indentfy-item-address {
  margin-bottom: 10px;
}

.checkout-complete
  .checkout-steps
  .division
  .select-address
  .item-address-saved
  .radio-button {
  border: 1px solid #000;
  height: 30px;
  width: 30px;
  margin-right: 20px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkout-complete .checkout-steps .division .select-address select {
  border: 1px solid #000;
  padding: 10px;
}

.checkout-complete .checkout-steps .division .input-address select {
  border: 1px solid #000;
  padding: 10px;
  margin-left: 10px;
}

.checkout-complete .checkout-steps .division .input-address .duple-input {
  display: flex;
}

.checkout-complete .checkout-steps .division .input-address .date-separator {
  width: 10px;
}

.checkout-complete .checkout-steps .division .input-address .unique-input p {
  text-align: left;
  color: #000;
  margin-left: 10px;
  margin-top: 10px;
}

.checkout-complete .checkout-steps .division .input-address .unique-input {
  text-align: left;
  color: #000;
  margin-top: 10px;
}

.checkout-complete
  .checkout-steps
  .division
  .input-address
  .unique-input
  label {
  margin-left: 10px;
}

.checkout-complete
  .checkout-steps
  .division
  .input-address
  .unique-input
  input {
  border: 1px solid #000;
  padding: 10px;
  margin: 5px;
  margin-left: 10px;
}

#input-mask {
  border: 1px solid #000;
  padding: 10px;
  margin: 5px;
  margin-left: 10px;
}

.checkout-complete
  .checkout-steps
  .division
  .input-address
  .unique-input
  .error {
  color: red;
}

.checkout-complete
  .checkout-steps
  .division
  .input-address
  .disabled-input
  input {
  background-color: rgba(45, 45, 45, 0.3);
}

.checkout-complete .checkout-steps .division .btn-add-address {
  display: flex;
  justify-content: flex-end;
}

.checkout-complete .checkout-steps .division .btns-add-address-options {
  display: flex;
}

.checkout-complete .checkout-steps .division .btn-add-address .btn-detail {
  background-color: #5e984c;
  min-width: 200px;
  color: #fff;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  max-width: 300px;
  padding: 16px;
  border-radius: 5px;
  margin: 20px 0px;
}

.checkout-complete .checkout-steps .division .input-address .down-input {
  display: flex;
}

.checkout-complete
  .checkout-steps
  .division
  .input-address
  .duple-input
  .unique-input {
  margin-left: 10px;
}

.checkout-complete .header {
  background-color: #fff;
  border-bottom: 1px solid #ededed;
  z-index: 2;
}

.checkout-complete .logo-bag {
  width: 100px;
  padding: 20px;
  margin-left: 30px;
}

.checkout-complete .checkout-detail .info {
  border: 1px solid #f3f3f3;
  margin-left: 30px;
  width: 60%;
  margin-bottom: 20px;
}

.checkout-complete .checkout-detail .info .title {
  text-align: left;
  font-weight: bold;
  font-size: 20px;
  padding: 20px;
}

.checkout-complete .checkout-detail .info .subprice,
.checkout-complete .checkout-detail .info .total {
  display: flex;
  text-align: left;
  padding: 20px;
}

.checkout-complete .checkout-detail .info .item-detail-info {
  display: flex;
  margin-bottom: 20px;
}

.checkout-complete .checkout-detail .info .item-detail-info .detail-buy {
  font-size: 12px;
  text-align: left;
}

.checkout-complete .checkout-detail .info .item-detail-info .detail-buy .price {
  font-weight: bold;
  text-align: left;
}

.checkout-complete .checkout-detail .info .item-detail-info .img-product {
  max-width: 100px;
}

.checkout-complete .checkout-detail .info .price {
  text-align: right;
}

.checkout-complete .checkout-detail .info .total {
  background-color: silver;
}

.checkout-complete .checkout .checkout-steps .division .delivery-form-options {
  display: flex;
  border-bottom: 1px solid #a0a0a0;
}

.checkout-complete
  .checkout
  .checkout-steps
  .division
  .delivery-form-options
  h3 {
  margin: 15px 0px;
}

.checkout-complete
  .checkout
  .checkout-steps
  .division
  .delivery-form-options
  .store-take {
  display: flex;
  text-align: left;
}

.checkout-complete
  .checkout
  .checkout-steps
  .division
  .delivery-form-options
  .store-take
  .select {
  border: 1px solid #000;
  width: 25px;
  height: 25px;
  border-radius: 15px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#message_error {
  font-size: 20px;
  font-weight: 400;
  color: black;
}

.checkout-complete .modal-container #message_error {
  font-weight: bold;
}

#btn_error {
  background-color: black;
  padding: 10px;
  font-weight: 700;
  border-radius: 10px;
  color: white;
}

#division {
  color: #000000;
  text-align: left;
  margin-bottom: 20px;
  margin-top: 50px;
}

#wrong_icon {
  color: red;
}

#moves {
  margin-top: 30px;
  width: 300px;
  display: inline-flex;
}

#moves button {
  padding: 10px;
  border-radius: 10px;
}

#previous {
  margin-right: 10px;
}

#next {
  margin-left: 10px;
  background-color: limegreen;
}

#division p {
  margin-top: 10px;
}

#resumo_txt {
  font-size: 16px;
  text-align: left;
  margin-top: 10px;
}

#checkout select {
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #ffffff;
  border: 1px solid #e4e4e4;
  padding: 10px;
  width: 300px;
}

#info {
  font-size: 12px;
  text-align: left;
}

#checkout input {
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 300px;
  border: 1px solid #e4e4e4;
  padding: 10px;
  border-radius: 5px;
}

#ct_address {
  text-align: left;
  font-size: 12px;
}

#button_ {
  margin-top: 20px;
  margin-bottom: 20px;
  align-items: flex-start;
}

#button_back_finalizar {
  color: #a0a0a0;
  width: 200px;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 5px;
}

#btn_text {
  display: block;
  padding: 10px;
  color: #ffffff;
  font-weight: 600;
  background-color: #8d816b;
  border: none;
  width: 200px;
}

#numeracao {
  background-color: #8d816b;
  width: 40px;
  text-align: center;
  border-radius: 20px;
  margin-right: 20px;
}

#numeracao h1 {
  color: "white";
}

#divisao_card {
  display: inline-flex;
}

#divisao_card input {
  width: 130px;
  margin-right: 40px;
}

#topico {
  display: inline-flex;
  align-items: center;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.checkout-complete .material-icons {
  width: 20px;
}

.checkout-complete .modal-header {
  display: flex;
  align-items: center;
  justify-items: center;
  flex-direction: row;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-container .pedidorealizado {
  color: green;
  font-weight: bold;
}

.modal-container .material-icons {
  color: green;
}

.modal-container .modal-Footerr {
  background-color: black;
  border-radius: 20px;
}

.modal-container .modal-Footerr .footer-text {
  color: white;
  padding: 0px;
  text-transform: uppercase;
  font-weight: bold;
}

.modal-container .modal-Footerr .btn-ver-pedidos {
  margin: 20px;
}

.checkout-complete
  .checkout
  .delivery-form-options
  .checkout-forma-entrega-divisoria {
  border-left: 1px solid #ccc;
  padding-left: 20px;
  padding-bottom: 20px;
}

@media screen and (max-width: 800px) {
  .checkout-complete .checkout {
    display: flex;
    flex-direction: column;
  }

  .checkout-complete .checkout .duple-input {
    display: flex;
    flex-direction: column;
  }

  .checkout-complete .checkout input {
    max-width: 90%;
  }

  .checkout-complete .checkout .btns-add-address-options {
    display: flex;
    flex-direction: column;
  }

  .checkout-complete .checkout .division .btn-add-address {
    display: flex;
    justify-content: center;
  }

  .checkout-complete .checkout .division .select-address {
    display: flex;
    flex-direction: column;
    margin: 10px;
  }

  .checkout-complete .checkout .select-address .item-address-saved {
    margin: 0px;
  }

  .checkout-complete
    .checkout
    .select-address
    .item-address-saved
    .item-address-saved-info {
    display: flex;
    flex-direction: column;
  }

  .checkout-complete .checkout .delivery-form-options {
    display: flex;
    flex-direction: column;
    text-align: start;
  }

  .checkout-complete
    .checkout
    .delivery-form-options
    .checkout-forma-entrega-divisoria {
    border-left-width: 0px;
  }
}
</style>
